<template>
	<div class="jikaoJs-container">
		<div class="inner-container">
			<!-- Left Content: Exam Title -->
			<div class="main-content-wrapper">
				<div class="exam-wrapper" ref="examWrap">
					<div class="end-page-box">
						<div class="end-title">模拟机考已结束</div>
						<div class="end-actions">
							<div class="action-btn" @click="handleRetryExam">重新机考</div>
							<div class="action-btn" @click="handleReSelect">重新选题</div>
							<!-- <div class="action-btn" @click="handleEndExam">结束机考</div> -->
							<div class="action-btn" @click="handleViewAnswer">查看答案</div>
						</div>
					</div>
				</div>

				<div class="bottom-bar">
					<div class="audio-wave" ref="waveWrap">
						<canvas class="audio-wave-canvas" ref="waveCanvas"></canvas>
					</div>
				</div>
			</div>

			<!-- Right Sidebar -->
			<div class="sidebar">
				<div class="sidebar-header">
					<div class="header-item">
						<div class="label">考生</div>
					</div>
					<div class="header-item">
						<div class="label">机位</div>
					</div>
				</div>

				<div class="user-seat-panel">
					<div class="seat-box avatar-box">
						<img v-if="infoData.avatar" :src="$imgUrl + infoData.avatar" class="seat-avatar-img" />
						<div v-else class="seat-avatar-placeholder">
							<i class="el-icon-user-solid"></i>
						</div>
					</div>
					<div class="seat-box number-box">
						<div class="seat-number">{{ seatNumber }}</div>
					</div>
				</div>

				<div class="user-info">
					<div class="info-group">
						<div class="info-label">姓名</div>
						<div class="info-value name">{{ infoData.nickName }}</div>
					</div>
					<div class="info-group">
						<div class="info-label">准考证号</div>
						<div class="info-value ticket">{{ infoData.phonenumber }}</div>
					</div>
					<div class="info-divider"></div>
				</div>

				<div class="volume-control">
					<div class="volume-label">音量调节</div>
					<div class="slider-wrapper">
						<img src="@/assets/svg/volume_icon.svg" alt="volume" class="volume-icon" />
						<el-slider v-model="volume" :min="0" :max="100" @change="handleVolumeChange"></el-slider>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import { mapState } from 'vuex';
const AUDIO_VOLUME_STORAGE_KEY = 'jikaoAudioVolume';
const SEAT_NUMBER_STORAGE_KEY = 'jikaoSeatNumber';
export default {
	name: 'jikaoJs',
	data() {
		return {
			paperId: '',
			recordId: '',
			seatNumber: 50,
			volume: 50
		};
	},
	computed: {
		...mapState(['infoData']),
	},
	created() {
		
	},
	mounted() {
		this.paperId = this.$route.query.paperId || '';
		this.recordId = this.$route.query.recordId || '';
		this.syncSavedVolume();
		this.handleVolumeChange(this.volume);
		this.getSeatNumber();
		this.$nextTick(() => {
			this.initWaveIdle();
		});
	},
	beforeDestroy() {
		this.unbindWaveResizeObserver();
	},
	methods: {
		handleRetryExam() {
			const q = (this.$route && this.$route.query) ? this.$route.query : {};
			const toInt = (v) => {
				if (v === undefined || v === null || v === '') return null;
				const n = Number(v);
				return Number.isFinite(n) ? n : null;
			};
			const toLong = (v) => {
				const n = toInt(v);
				if (n === null) return null;
				if (n <= 0) return null;
				return n;
			};
			const examQuery = {
				classification: toInt(q.classification),
			};
			if (examQuery.classification === 1) {
				examQuery.paperAId = toLong(q.paperAId);
				examQuery.sourceA = toInt(q.sourceA);
				examQuery.paperBId = toLong(q.paperBId);
				examQuery.sourceB = toInt(q.sourceB);
			} else if (examQuery.classification === 2) {
				examQuery.paperId = toLong(q.paperId);
			}
			this.$router.push({ path: '/jikao', query: { ...examQuery } });
		},
		handleReSelect() {
			this.$router.push({
				path: '/taotiziyuan'
			});
		},
		handleEndExam() {
			this.$router.push({
				path: '/taotiziyuan'
			});
		},
		handleViewAnswer() {
			this.$router.push({
				path: '/jikaoZj',
				query: {
					txt: '模拟机考~考试完成',
					tabFtxt: '模拟机考',
					paperId: this.paperId,
					recordId: this.recordId
				}
			});
		},
		handleVolumeChange(val) {
			const volume = Math.max(0, Math.min(100, Number(val)));
			this.volume = volume;
			try {
				window.localStorage.setItem(AUDIO_VOLUME_STORAGE_KEY, String(volume));
			} catch (e) {}
			if (this.$audio && typeof this.$audio.playvolume === 'function') {
				this.$audio.playvolume(volume / 100);
			}
		},
		getSavedVolume() {
			try {
				const raw = window.localStorage.getItem(AUDIO_VOLUME_STORAGE_KEY);
				if (raw === null || raw === '') return null;
				const volume = Math.max(0, Math.min(100, Number(raw)));
				return Number.isFinite(volume) ? volume : null;
			} catch (e) {
				return null;
			}
		},
		getSeatNumber() {
			try {
				const raw = window.localStorage.getItem(SEAT_NUMBER_STORAGE_KEY);
				if (raw === null || raw === '') return null;
				this.seatNumber = Number(raw);
			} catch (e) {
				return 1;
			}
		},
		syncSavedVolume() {
			const savedVolume = this.getSavedVolume();
			if (savedVolume === null) return;
			this.volume = savedVolume;
		},
		initWaveIdle() {
			if (this._waveInited) return;
			this._waveInited = true;
			this._wave = {
				cssW: 0,
				cssH: 0,
				dpr: 1,
				ctx2d: null,
				ro: null,
				onResize: null
			};
			this.bindWaveResizeObserver();
			this.ensureWaveCanvasSize();
			this.drawWaveIdle();
		},
		bindWaveResizeObserver() {
			const w = this._wave;
			if (!w) return;
			this.unbindWaveResizeObserver();
			const el = this.$refs.waveWrap;
			if (!el) return;
			if (typeof ResizeObserver !== 'undefined') {
				w.ro = new ResizeObserver(() => {
					this.ensureWaveCanvasSize();
					this.drawWaveIdle();
				});
				w.ro.observe(el);
				return;
			}
			w.onResize = () => {
				this.ensureWaveCanvasSize();
				this.drawWaveIdle();
			};
			window.addEventListener('resize', w.onResize);
		},
		unbindWaveResizeObserver() {
			const w = this._wave;
			if (!w) return;
			if (w.ro) {
				try {
					w.ro.disconnect();
				} catch (e) {}
				w.ro = null;
			}
			if (w.onResize) {
				window.removeEventListener('resize', w.onResize);
				w.onResize = null;
			}
		},
		ensureWaveCanvasSize() {
			const w = this._wave;
			if (!w) return;
			const wrap = this.$refs.waveWrap;
			const canvas = this.$refs.waveCanvas;
			if (!wrap || !canvas) return;
			const rect = wrap.getBoundingClientRect();
			const cssW = Math.max(1, Math.floor(rect.width));
			const cssH = Math.max(1, Math.floor(rect.height));
			const dpr = Math.max(1, Math.floor((window.devicePixelRatio || 1) * 100) / 100);
			if (cssW === w.cssW && cssH === w.cssH && dpr === w.dpr && canvas.width && canvas.height) return;
			w.cssW = cssW;
			w.cssH = cssH;
			w.dpr = dpr;
			canvas.width = Math.max(1, Math.floor(cssW * dpr));
			canvas.height = Math.max(1, Math.floor(cssH * dpr));
			canvas.style.width = `${cssW}px`;
			canvas.style.height = `${cssH}px`;
			const ctx2d = canvas.getContext('2d');
			w.ctx2d = ctx2d;
			if (ctx2d) {
				ctx2d.setTransform(dpr, 0, 0, dpr, 0, 0);
			}
		},
		drawWaveIdle() {
			const w = this._wave;
			if (!w || !w.ctx2d) return;
			const ctx = w.ctx2d;
			const width = w.cssW || 0;
			const height = w.cssH || 0;
			if (!width || !height) return;
			ctx.clearRect(0, 0, width, height);
			const barW = 2;
			const gap = 3;
			const step = barW + gap;
			const count = Math.max(1, Math.min(160, Math.floor(width / step)));
			const total = count * step - gap;
			const x0 = Math.max(0, (width - total) / 2);
			ctx.fillStyle = 'rgba(255,255,255,0.35)';
			const base = Math.max(2, Math.floor(height * 0.18));
			for (let i = 0; i < count; i++) {
				const x = x0 + i * step;
				const h = base;
				const y = Math.floor((height - h) / 2);
				ctx.fillRect(x, y, barW, h);
			}
		}
    }
};
</script>

<style lang="scss" scoped>
// .jikaoJs-container {
// 	display: flex;
// 	align-items: center;
// 	justify-content: center;
// 	height: 100vh;
// 	background-color: #f0f2f5;
// }


</style>

<style lang="scss" scoped>

.jikaoJs-container {
	display: flex;
	justify-content: center;
	height: 100vh;
	background-color: #f0f2f5;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;

	.inner-container {
		display: flex;
		width: 1200px;
		height: 100%;
		background-color: #fff;
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
	}
}

/* Left Content Styles */
.main-content-wrapper {
	flex: 1;
	display: flex;
	flex-direction: column;
	position: relative;

	.exam-wrapper {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		position: relative;
		padding: 40px 60px;
		overflow-y: auto;
		min-height: 0;

		.end-page-box {
			background-color: #f0faff;
			border-radius: 12px;
			padding: 40px 80px;
			text-align: center;
			box-shadow: 0 4px 12px rgba(0, 128, 255, 0.05);
		}

		.end-title {
			font-size: 28px;
			font-weight: bold;
			color: #0080ff;
			margin-bottom: 30px;
			letter-spacing: 2px;
		}

		.end-actions {
			display: flex;
			gap: 15px;
		}

		.action-btn {
			background-color: #0080ff;
			color: white;
			padding: 10px 24px;
			border-radius: 6px;
			font-size: 14px;
			cursor: pointer;
			transition: background-color 0.2s;

			&:hover {
				background-color: #0066cc;
			}
		}
	}

	/* 注意事项模块样式 */
	.zhuyishixiang-container {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0;
	}

	.content-wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
	}

	.notice-box {
		background-color: #f0faff;
		border-radius: 10px;
		padding: 40px 60px;
		width: 100%;
		max-width: 800px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
		text-align: center;

		.notice-title {
			color: #f56c6c;
			font-size: 24px;
			font-weight: bold;
			margin-bottom: 30px;
			letter-spacing: 2px;
		}

		.notice-content {
			text-align: left;
			margin-bottom: 30px;

			p {
				color: #409EFF;
				font-size: 16px;
				line-height: 1.8;
				margin-bottom: 15px;
				text-indent: 0;
			}
		}

		.notice-footer {
			color: #409EFF;
			font-size: 20px;
			font-weight: bold;
			letter-spacing: 1px;
		}
	}

	.exam-header {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0 20px 60px;

		.exam-title-card {
			width: 100%;
			max-width: 980px;
			min-height: 230px;
			background: #f0fdff;
			border-radius: 16px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			text-align: center;
			padding: 20px 30px;
			box-sizing: border-box;
		}

		.exam-title {
			font-size: 34px;
			line-height: 1.2;
			font-weight: bold;
			color: #0080ff;
			margin-bottom: 14px;
		}

		.exam-subtitle {
			font-size: 34px;
			line-height: 1.2;
			font-weight: bold;
			color: #0080ff;
		}
	}

	.section-content {
		flex: 1;
		display: flex;
		flex-direction: column;


		.section-title {
			font-size: 24px;
			font-weight: bold;
			color: #000;
			margin-bottom: 20px;
			flex-shrink: 0;
		}

		.instruction-box {
			background-color: #e6f3ff;
			border-radius: 8px;
			padding: 20px;
			font-size: 16px;
			line-height: 1.6;
			color: #333;
			text-align: justify;
			margin-bottom: 30px;
			flex-shrink: 0;
		}

		.prompt-box {
			padding: 15px 20px;
			font-weight: bold;
			font-size: 16px;
			color: #000;
			background-color: #fff;
			align-self: flex-start;
			margin-bottom: 20px;
		}

		.kaoshiH {
			margin-bottom: 40px;
		}

		.kaoshiT {
			margin-bottom: 44px;
			scroll-margin-top: 20px;

			&.is-active-question {
				outline: 2px solid #0080ff;
				outline-offset: 6px;
				border-radius: 6px;
			}

			.kaoshiXx {
				padding-left: 102px;

				p {
					margin-bottom: 36px;
					font-size: 18px;
					cursor: pointer;

					&:hover {
						color: #1d7b3a;
					}

					&:last-of-type {
						margin-bottom: 0;
					}
				}

				.active {
					color: #1d7b3a;
				}
			}

			.kaoshiWt {
				display: flex;
				font-weight: bold;
				margin-bottom: 36px;

				.kaoshiDa {
					width: 72px;
					margin-right: 30px;
					position: relative;
					display: flex;
					justify-content: space-between;
					line-height: 1.2;

					span {
						position: absolute;
						top: 50%;
						left: 50%;
						transform: translate(-50%, -50%);
					}
				}
			}
		}

		.question-list {
			.question-item {
				margin-bottom: 30px;

				.question-header {
					display: flex;
					align-items: center;
					margin-bottom: 15px;
					font-size: 18px;
					font-weight: bold;
					color: #333;

					.answer-box {
						min-width: 40px;
						display: inline-flex;
						justify-content: center;
						margin-right: 15px;
						color: #0080ff;
						font-family: monospace;
					}
				}

				.options-list {
					padding-left: 60px;

					.option-item {
						margin-bottom: 10px;
						font-size: 16px;
						color: #666;
					}
				}
			}
		}
	}

	.bottom-bar {
		height: 60px;
		background-color: #0080ff;
		display: flex;
		align-items: center;
		padding: 0 150px;
		color: #fff;
		position: relative;
		overflow: hidden;

		.debug-toggle {
			position: absolute;
			top: 2px;
			right: 2px;
			width: 20px;
			height: 20px;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			z-index: 100;
			opacity: 0.5;
			transition: all 0.2s;

			&:hover {
				opacity: 1;
				transform: scale(1.1);
			}

			i {
				font-size: 14px;
				color: #fff;
			}
		}

		.indicate-box {
			display: flex;
			align-items: center;
			position: absolute;
			top: 0;
			left: 0;
			bottom: 0;
			width: 150px;
			display: flex;
			align-items: center;

			.indicate-light {
				width: 10px;
				height: 10px;
				background-color: #00FF08;
				border-radius: 50%;
				margin-left: auto;

				&.is-red {
					background-color: #FF3B30;
				}
			}
			.indicate-text-box {
				width: 100px;
				display: flex;
				align-items: center;
				justify-content: center;
				font-weight: bold;
				font-size: 22px;
				color: #FFFFFF;
				line-height: 22px;
				text-align: center;
			}
		}

		.count-down {
			position: absolute;
			top: 0;
			left: 0;
			bottom: 0;
			width: 60px;
			display: flex;
			align-items: center;
			justify-content: center;
			z-index: 100;
		}

		.status-indicator {
			display: flex;
			align-items: center;
			margin-right: 20px;
			flex-shrink: 0;

			.dot {
				width: 10px;
				height: 10px;
				background-color: #67c23a;
				border-radius: 50%;
				margin-right: 10px;
				box-shadow: 0 0 4px rgba(255, 255, 255, 0.5);
			}

			.status-text {
				font-size: 18px;
				font-weight: bold;
			}
		}

		.dotted-line {
			flex: 1;
			height: 0;
			border-bottom: 2px dotted rgba(255, 255, 255, 0.6);
			margin-top: 5px;
		}

		.audio-wave {
			flex: 1;
			height: 20px;
			display: flex;
			align-items: center;
			min-width: 0;
			/* 让波形始终占据空间 */
			width: 100%;
		}

		.audio-wave-canvas {
			width: 100%;
			height: 20px;
			display: block;
		}

		.debug-panel {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background-color: #0080ff;
			/* 遮盖底部背景 */
			z-index: 50;
			/* 确保在波形之上 */

			display: flex;
			flex-direction: column;
			justify-content: center;
			padding: 0 40px;
			/* 避开右侧开关 */
			box-sizing: border-box;

			.debug-controls {
				display: flex;
				align-items: center;
				margin-bottom: 2px;

				.debug-end-btn {
					margin-left: 12px;
				}

				.el-radio-button__inner {
					padding: 5px 10px;
				}

				.node-info {
					margin-left: 15px;
					font-size: 12px;
					color: rgba(255, 255, 255, 0.9);
					display: flex;
					align-items: center;
					overflow: hidden;

					.node-id {
						background: rgba(0, 0, 0, 0.2);
						padding: 0 4px;
						border-radius: 2px;
						margin-right: 6px;
						font-family: monospace;
					}

					.node-label {
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						max-width: 300px;
					}
				}
			}

			.debug-slider-row {
				display: flex;
				align-items: center;

				.time-label {
					font-size: 12px;
					font-family: monospace;
					margin-right: 10px;
					min-width: 50px;
					text-align: right;
				}

				.debug-slider {
					flex: 1;
					width: 0;
					/* fix flex layout issue */

					::v-deep .el-slider__runway {
						margin: 8px 0;
						background-color: rgba(255, 255, 255, 0.3);
						height: 4px;
					}

					::v-deep .el-slider__bar {
						background-color: #fff;
						height: 4px;
					}

					::v-deep .el-slider__button-wrapper {
						top: -16px;
					}

					::v-deep .el-slider__button {
						border-color: #fff;
						width: 10px;
						height: 10px;
					}
				}
			}
		}

		.audio-debug {
			flex: 1;
			display: flex;
			align-items: center;
			min-width: 0;
		}

		.audio-debug-meta {
			margin-right: 12px;
			flex-shrink: 0;
			text-align: right;
		}

		.audio-debug-node {
			font-size: 12px;
			line-height: 1.2;
			opacity: 0.9;
			max-width: 140px;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		.audio-debug-time {
			font-size: 12px;
			line-height: 1.2;
			font-family: monospace;
			opacity: 0.9;
		}

		.audio-debug-slider {
			flex: 1;
			min-width: 0;
		}
	}
}

/* Right Sidebar Styles */
.sidebar {
	width: 300px;
	background-color: #e9f6ff;
	padding: 34px 25px 0;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;

	.sidebar-header {
		display: flex;
		justify-content: space-between;
		margin-bottom: 15px;

		.header-item {
			flex: 1;
			text-align: center;

			.label {
				font-size: 19px;
				line-height: 1;
				font-weight: bold;
				color: #000;
				letter-spacing: 6px;
			}
		}
	}

	.user-seat-panel {
		display: flex;
		margin: 0 auto 26px;

		.seat-box {
			width: 125px;
			height: 125px;
			border: 1px solid #bfc6d1;
			box-sizing: border-box;
			background-color: #fff;
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.avatar-box {
			border-right: none;
		}

		.seat-avatar-img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}

		.seat-avatar-placeholder {
			font-size: 78px;
			color: #c4c4c4;
			line-height: 1;
		}

		.seat-number {
			font-size: 62px;
			font-weight: 500;
			line-height: 1;
			color: #0080ff;
			font-family: Arial, sans-serif;
		}
	}

	.user-info {
		margin-bottom: 20px;

		.info-group {
			margin-bottom: 16px;

			.info-label {
				font-size: 13px;
				line-height: 1.1;
				color: #575757;
				margin-bottom: 8px;
				letter-spacing: 2px;
			}

			.info-value {
				font-size: 13px;
				line-height: 1.2;
				color: #0080ff;
				font-weight: bold;
				letter-spacing: 1px;

				&.ticket {
					font-family: Arial, sans-serif;
				}
			}
		}

		.info-divider {
			border-top: 1px solid #b8c7d8;
			margin-top: 26px;
		}
	}

	/* Question Card Styles */
	.question-card {
		background-color: #fff;
		border-radius: 8px;
		padding: 20px 10px 20px 20px;
		flex: 1;
		/* Fill remaining height */
		display: flex;
		flex-direction: column;
		min-height: 0;
		/* Important for nested scrolling */
		margin-bottom: 20px;
		/* Space before volume control */
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);

		.card-content {
			flex: 1;
			overflow-y: auto;
			// padding-right: 5px;
			/* Prevent scrollbar overlapping content slightly */

			/* Custom scrollbar for webkit */
			&::-webkit-scrollbar {
				width: 6px;
			}

			&::-webkit-scrollbar-thumb {
				background-color: #dcdfe6;
				border-radius: 3px;
			}

			&::-webkit-scrollbar-track {
				background-color: #f5f7fa;
			}
		}

		.section-group {
			margin-bottom: 20px;

			.section-header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-bottom: 10px;

				.section-name {
					font-weight: bold;
					font-size: 14px;
					color: #333;
				}

				.show-answer {
					font-size: 12px;
					color: #666;
					cursor: pointer;
					display: flex;
					align-items: center;
					margin-right: 10px;


					i {
						margin-right: 4px;
					}
				}
			}

			.question-grid {
				display: flex;
				flex-wrap: wrap;
				gap: 10px;

				.question-item {
					width: 32px;
					height: 32px;
					border: 1px solid #f56c6c;
					border-radius: 4px;
					display: flex;
					align-items: center;
					justify-content: center;
					font-size: 14px;
					color: #f56c6c;
					cursor: pointer;

					&:hover {
						border-color: #0080ff;
						color: #0080ff;
					}

					&.answered {
						background-color: #0080ff;
						border-color: #0080ff;
						color: #fff;
					}

					&.disabled {
						cursor: not-allowed;
						opacity: 0.45;

						&:hover {
							border-color: #f56c6c;
							color: #f56c6c;
						}
					}

				}
			}
		}

		.card-footer {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-top: 20px;
			padding-top: 15px;
			border-top: 1px solid #f0f0f0;

			.paper-type {
				font-size: 18px;
				font-weight: bold;
				color: #0080ff;
			}

			.status-text {
				font-size: 12px;
				color: #0080ff;
				display: flex;
				align-items: center;

				i {
					margin-right: 4px;
				}
			}
		}
	}

	.volume-control {
		border-top: 1px solid #d0e0f0;
		height: 60px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		margin-top: auto;

		.volume-label {
			position: absolute;
			top: 0;
			left: 50%;
			transform: translate(-50%, -50%);
			background-color: #e6f3ff;
			padding: 0 10px;
			color: #666;
			font-size: 14px;
		}

		.slider-wrapper {
			display: flex;
			align-items: center;
			width: 100%;
			padding: 0 10px;

			.volume-icon {
				font-size: 24px;
				margin-right: 15px;
				color: #333;
				width: 30px;
				height: 30px;
			}

			.el-slider {
				flex: 1;
			}
		}
	}
}

/* Floating Step Control Styles */
.floating-step-control {
	position: fixed;
	left: 20px;
	bottom: 20px;
	z-index: 9999;
	display: flex;
	flex-direction: column-reverse;
	align-items: flex-start;

	.step-toggle-btn {
		width: 40px;
		height: 40px;
		background-color: #0080ff;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		box-shadow: 0 2px 10px rgba(0, 128, 255, 0.4);
		transition: all 0.3s;
		z-index: 10001;

		&:hover {
			transform: scale(1.1);
			background-color: #0066cc;
		}
	}

	.step-panel-content {
		background-color: rgba(0, 0, 0, 0.7);
		border-radius: 8px;
		padding: 10px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
		width: 300px;
		max-height: 400px;
		overflow-y: auto;
		backdrop-filter: blur(5px);
		margin-bottom: 15px;
		/* Space between content and toggle button */
		transform-origin: bottom left;

		/* Scrollbar styling */
		&::-webkit-scrollbar {
			width: 4px;
		}

		&::-webkit-scrollbar-thumb {
			background-color: rgba(255, 255, 255, 0.3);
			border-radius: 2px;
		}

		.step-panel-header {
			color: #fff;
			font-size: 14px;
			font-weight: bold;
			margin-bottom: 10px;
			padding-bottom: 5px;
			border-bottom: 1px solid rgba(255, 255, 255, 0.2);
			display: flex;
			justify-content: space-between;
			align-items: center;
		}

		.step-list {
			display: flex;
			flex-wrap: wrap;
			gap: 8px;

			.step-item {
				padding: 6px 12px;
				background-color: rgba(255, 255, 255, 0.2);
				border: 1px solid rgba(255, 255, 255, 0.3);
				border-radius: 4px;
				cursor: pointer;
				font-size: 12px;
				color: #fff;
				transition: all 0.2s;
				white-space: nowrap;

				&:hover {
					background-color: rgba(255, 255, 255, 0.3);
				}

				&.active {
					background-color: #0080ff;
					border-color: #0080ff;
					color: #fff;
					font-weight: bold;
					box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
				}
			}
		}
	}
}

/* Transition effects */
.fade-enter-active,
.fade-leave-active {
	transition: all 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

.fade-enter,
.fade-leave-to {
	opacity: 0;
	transform: translateY(20px) scale(0.9);
}

</style>
